<template>
  <div>
    <!-- 用户名 -->
    <div class="log_ui logTool login-with-pwd">
      <div class="dsib log_tool_outer vm">
        <input
          class="txt username vm"
          type="text"
          id="userNameInp"
          placeholder="输入帐号"
          tabindex="1"
          required
          :value="store.account"
          @input="updateStore('account', $event.target.value)"
        />
      </div>
    </div>
    <!-- 密码 -->
    <div class="log_ui logPass login-with-pwd">
      <span class="dsib vm" style="display:none;">密码:</span>
      <div class="dsib log_tool_outer vm" style="position: relative">
        <input
          class="txt userPass"
          :type="passwdType ? 'text' : 'password'"
          placeholder="输入密码"
          tabindex="2"
          required
          @input="updateStore('password', $event.target.value)"
        />
        <div class="pwd_icon" v-if="showpasswd" @click="passwdType = !passwdType">
          <img class="loading-icon" v-if="passwdType" src="../assets/images/icon_password_show.svg" />
          <img class="loading-icon" v-else src="../assets/images/icon_password_hide.svg" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import updateStore from '@/mixins/update-store';

export default {
  mixins: [updateStore],
  data() {
    return {
      passwdType: false,
      showpasswd: false,
    };
  },
  computed: {
  },
  created() {
    this.getPwdShow();
  },
  methods: {
    getPwdShow() {
      this.$api
        .pwdShow()
        .then((res) => {
          console.log(res.data.data);
          this.showpasswd = res.data.data.show_passwd;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="less" scoped>
  .pwd_icon {
    position: absolute;
    right: 12px;
    top: 12px;
    cursor: pointer;
    img {
      width: 18px;
    }
  }
</style>
